const SET_BILLING_INFO = 'SET_BILLING_INFO';
const SET_LOADING = 'SET_BILLING_LOADING';
const RESET_BILLING_INFO = 'RESET_BILLING_INFO';

export default {
    SET_BILLING_INFO,
    SET_LOADING,
    RESET_BILLING_INFO
};
